import script from "./relationChart.vue?vue&type=script&setup=true&lang=js"
export * from "./relationChart.vue?vue&type=script&setup=true&lang=js"

import "./relationChart.vue?vue&type=style&index=0&id=33dc51b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33dc51b2"]])

export default __exports__